var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selectAssignment == 'NewProject')?_c('NewProject',{ref:"newProject",on:{"close":_vm.closePopup,"updateView":_vm.updateView}}):(_vm.selectAssignment == 'LinkedOkr')?_c('LinkedOkr',{ref:"LinkedOkr",attrs:{"modalInfo":_vm.projectData},on:{"updateView":_vm.updateView,"close":_vm.closePopup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37bd6420","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cowork/general/project/modal/CreateProject.vue
// module id = null
// module chunks = 